const addErrorToInputField = (form, name, error) => {
    // find our input by name
    const field = form.querySelector('input[name="' + name + '"], textarea[name="' + name + '"], select[name="' + name + '"]')
    if (!field) {
        return;
    }

    // Find the row parent
    const parent = field.closest('.row')
    if (!parent) {
        return
    }

    // Add error class
    parent.classList.add('errorWrap')

    // Create validation message
    const validationMessage = document.createElement('div')
    validationMessage.classList.add('validationMessage')
    validationMessage.innerHTML = error

    // Append validation message to parent
    parent.appendChild(validationMessage)
}

const clearForm = (form) => {
    const errors = form.querySelectorAll('.errorWrap');

    errors.forEach((e) => {
        e.classList.remove('errorWrap')
        e.querySelector('.validationMessage').remove()
    });

    const successMessage = form.querySelector('.formSuccessMessage');
    successMessage && successMessage.remove()
}

const clearFormInput = (form, name) => {
    const field = form.querySelector('input[name="' + name + '"], textarea[name="' + name + '"], select[name="' + name + '"]')
    if (!field) {
        return
    }

    if (field.type === 'text' || field.type === 'email' || field.type === 'tel' || field.type === 'file') {
        field.value = ''
    }
}

$(document).ready(function () {
    'use strict'
    /**
     * Vanilla JS submits form to endpoint
     * Try catches res and errors
     * Appends success message after form
     */
    const forms = document.querySelectorAll('.js_oraNewsletterSignup')
    forms.forEach((f) => f.addEventListener('submit', async (e) => {
        e.preventDefault()
        const action = f.getAttribute('action')

        const submitEl = f.querySelector('button[type=submit]')
        submitEl.setAttribute('disabled', '')

        clearForm(f)

        const formData = new FormData(f)

        try {
            const res = await fetch(action, {
                method: 'POST',
                headers: new Headers({
                    'Accept': 'application/json'
                }),
                credentials: 'same-origin',
                body: formData,
            })

            const body = await res.json()

            if (!res.ok) {
                return await Promise.reject(body);
            }

            const { message } = body

            for (const [key] of formData) {
                clearFormInput(f, key)
            }

            if (!message) return

            f.style.display = 'none'

            const parent = f.closest('.oraNewsletterCta__form')


            if (parent) {
                const successMessage = document.createElement('div')
                successMessage.classList.add('formSuccessMessage')
                successMessage.innerHTML = message
                parent.appendChild(successMessage)
            }

        } catch (err) {
            const { errors } = err

            if (errors) {
                for (const [key, value] of Object.entries(errors)) {
                    addErrorToInputField(f, key, value)
                }
            }

            if (typeof grecaptcha !== 'undefined' && window.recaptcha_key !== '' && f.querySelectorAll('.js_g-recaptcha-response').length > 0) {
                recaptchaInitV3();
            }
        } finally {
            submitEl.removeAttribute('disabled')
        }
    }))
})